@if (isOnSignedOutPage()) {
<router-outlet></router-outlet>
} @else if (isRoyalCrownEmployee()) {
<rc-login-as />
} @else if(user()) {
<div class="d-flex container base">
  @if(!isMobile() && !customerView.isActive()){
  <rc-crowndesk-menu [user]="user()!" [menu]="menu()"></rc-crowndesk-menu>
  }
  <div class="d-flex flex-column w-100 overflow-hidden">
    <rc-top-bar [user]="user()!" [menu]="menu()"></rc-top-bar>
    <main class="main" [class.w-100]="isMobile() || isTablet()" [style.--itemAmount]="userSettings() ? userSettings()!.itemsPerPage : 10">
        <router-outlet></router-outlet>
    </main>
  </div>
</div>
} @else {
  <div class="sk-layout">

    <!-- Side menu skeleton — desktop only -->
    @if (!isMobile()) {
      <nav class="sk-menu">
        @for (i of [1,2,3,4,5,6,7]; track i) {
          <div class="sk-menu__item">
            <kendo-skeleton shape="circle" animation="pulse" class="sk-menu__icon"></kendo-skeleton>
            <kendo-skeleton shape="text"   animation="pulse" class="sk-menu__label"></kendo-skeleton>
          </div>
        }
        <div class="sk-menu__footer">
          <kendo-skeleton shape="text" animation="pulse" class="sk-menu__user-name"></kendo-skeleton>
          <kendo-skeleton shape="text" animation="pulse" class="sk-menu__user-sub"></kendo-skeleton>
        </div>
      </nav>
    }

    <!-- Right side: topbar + content -->
    <div class="sk-right">

      <!-- Top bar skeleton -->
      <header class="sk-topbar">
        <div class="sk-topbar__brand">
          <div class="top-bar__icon bgc-primary-500 border-radius-36"></div>
          <span class="sk-topbar__title">CROWN<span class="sk-topbar__accent">DESK</span></span>
        </div>
        @if (!isMobile()) {
          <kendo-skeleton shape="text" animation="pulse" class="sk-topbar__search"></kendo-skeleton>
        }
        <div class="sk-topbar__actions">
          <kendo-skeleton shape="circle" animation="pulse" class="sk-topbar__action"></kendo-skeleton>
          @if (isMobile()) {
            <kendo-skeleton shape="circle" animation="pulse" class="sk-topbar__action"></kendo-skeleton>
          }
        </div>
      </header>

      <!-- Content skeleton -->
      <div class="sk-content">
        <div class="sk-card">
          <div class="sk-card__header">
          <span class="mx-auto w-fit-content d-block">
            <span class="top-bar__title-text fw-900 fs-20 fc-primary-500">CROWN</span>
            <span class="top-bar__title-accent fs-20 fc-primary-500">DESK</span>
        </span>
<!--            <kendo-skeleton shape="text" animation="pulse" class="sk-card__title"></kendo-skeleton>-->
          </div>
          @if (userLoadError()) {
            <rc-app-load-error (retry)="retryLoadUser()" />
          } @else {
          <div class="sk-table">
            @for (i of [1,2,3,4,5,6,7,8]; track i) {
              <kendo-skeleton shape="text" animation="pulse" class="sk-table__row" [style.width]="(100 - (i % 4) * 10) + '%'"></kendo-skeleton>
            }
          </div>
          }
        </div>
      </div>

    </div>
  </div>
}
<div kendoDialogContainer></div>
